<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>人脸识别</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <span class="back" @click="$router.go(-1)"
                ><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span
            >
            <div class="imgList">
                <div>
                    <p>请使用微信扫描下方二维码进行实名认证</p>
                    <el-image
                        :src="qrBase64"
                        alt=""
                        class="dataPng"
                        style="margin-top: 0%"
                    >
                    </el-image>
                </div>
                <el-button round type="primary" @click="reload">{{
                    msg
                }}</el-button>
                <p class="error">若认证失败请<span @click="reload">刷新页面</span>重置二维码</p>
            </div>
        </div>
    </el-row>
</template>

<script>
import { faceApply } from "@http/user_center/faceIdent";
import { identification } from "@http/user_center/userInfo";
export default {
    name: "",
    data() {
        return {
            dataPng: require("@/assets/images/error.png"),
            huancun: require("@/assets/images/huancun.gif"),
            isShow: true,
            qrBase64: "",
            timer: null,
            bizToken: "",
            userInfo: {},
            msg: "正在获取认证状态，请稍后···",
            entStatus:'',
        };
    },
    async created() {
        let {authenticationStatus}=await identification();
        this.entStatus=authenticationStatus;
        if(this.entStatus==-1){
            //未认证去识别企业信息页
            this.$router.push({
                path: "/userCenter/AuthenticationName",
            });
        }else if(this.entStatus==4){
            //企业信息已识别，可以进行人脸
            this.reload();
        }else if(this.entStatus==6){
            //线下授权书申请审核中，去对公打款页
            this.$router.replace({
                path:'/userCenter/realName/enterpriseResult'
            })
        }else if(this.entStatus==10){
            //已完成认证
            this.$router.replace({
                path:'/userCenter/realName/enterpriseSuccess'
            })
            //this.$msg('您的企业认证已完成','success');
        }else{
            this.$router.replace({
                path:'/userCenter/AuthenticationName'
            })
        }
        
    },
    methods: {
        async init() {
            let clientId = this.$getlocalStorage("queryData")
                ? this.$getlocalStorage("queryData").clientId
                : "";
            let res = await faceApply({ clientId });
            this.qrBase64 = `data:image/jpg;base64,${res.qrBase64}`;
            this.bizToken = res.bizToken;
            if (res) this.msg = "认证成功，刷新页面";
            this.$store.dispatch('userInfo/setLawyerInfo', {})
        },
        async reload() {
            this.userInfo = await identification({});
            if (this.userInfo.enterprise.type === 0) {
                this.init();
            } else {
                if(this.userInfo.enterprise.type === 1){
                  if(this.userInfo.enterprise.status==0){
                      this.$msg("您当前存在申请记录，请耐心等待审核", "success");
                  }else{
                      this.$msg("企业法人实名成功", "success");
                  }
                }else{
                    this.$msg("企业法人实名成功", "success");
                }
                setTimeout(() => {
                    this.$router.push({
                        //path: "/userCenter/realName/enterpriseSign",
                        path:'/userCenter/realName/enterpriseSuccess'
                    });
                }, 1500);
            }
        },
    },
    destroyed() {},
};
</script>

<style scoped lang="less">
.mianContent{
    position: relative;
    .back{
        position:absolute;
        right: 30px;
        top:-30px;
        font-size: 14px;
        cursor: pointer;
        &:hover{
            color:#10A0E9
        }
    }
}
.imgList {
    margin: 30px auto;
    text-align: center;
    .el-image {
        width: 300px;
        height: 300px;
    }
    /deep/ .image-slot {
        background: #f5f7fa;
        height: 100%;
    }
}
.dataPng {
    width: 163px;
    height: 128px;
    margin: 30px auto;
    background-size: cover;
    margin-top: 10%;
}
.bot {
    margin: 10px auto;
    text-align: center;
}
p {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
}
.el-button {
    margin-top: 40px;
}
b {
    color: #3f7df7;
}
.huancun {
    height: 75px;
    width: 75px;
    margin-bottom: 10px;
}
#canvas {
    width: 50% !important;
    height: auto !important;
    left: 127px;
    top: 237px;
}
.error{
  margin-top:20px;
  font-size: 14px;
  color: #999;
  span{
    color: #3f7df7;
    cursor: pointer;
  }
}
</style>
